<template>
  <div>
    <div class="exr-items">
      <el-form-item label="词汇">
        <div class="exr-item-wrap" v-for="(value, key) in form.items" :key="key">
          <div class="exr-item">
            <el-input v-model="value.text" @paste.native.capture.prevent="handlePasteItems($event, key)"></el-input>
            <PinyinInput v-model="value.pinyin" v-if="config.itemsPinyin" :text="value.text" :uppercase="false"></PinyinInput>
            <el-button type="danger" tabindex="-1" icon="el-icon-delete" @click="removeItem(key)"></el-button>
            <el-button icon="el-icon-plus" tabindex="-1" v-if="showAddItem" @click="addItem(key)"></el-button>
          </div>
          <PinyinPreview v-if="config.itemsPinyin" :text="value.text" :pinyin="value.pinyin" popover></PinyinPreview>
        </div>
      </el-form-item>
    </div>
    <div v-if="config.subject === 'line'">
      <el-form-item label="正文">
        <div class="exr-form-subject">
          <el-input v-model="form.subject"></el-input>
          <PinyinInput v-model="form.subjectPinyin" v-if="config.subjectPinyin" :text="form.subject"></PinyinInput>
        </div>
      </el-form-item>
      <PinyinPreview v-if="config.subjectPinyin" :text="form.subject" :pinyin="form.subjectPinyin" popover offsets></PinyinPreview>
    </div>
    <div v-else-if="config.subject === 'text' || config.subject === 'dialog'">
      <el-form-item label="正文" @change.native.capture="handleDialogText(form, 'subject', 'subjectPinyin')">
        <PinyinGridInput v-if="config.subjectPinyin" :text.sync="form.subject" :pinyin.sync="form.subjectPinyin"></PinyinGridInput>
        <el-input v-else type="textarea" v-model="form.subject" resize="none" :autosize="{minRows:2}"></el-input>
      </el-form-item>
    </div>
    <el-form-item label="图片" v-if="config.image">
      <ImageInput v-model="form.image" :desc.sync="form.imageDesc"></ImageInput>
    </el-form-item>
    <el-form-item label="音频" v-if="config.audio">
      <FileInput v-model="form.audio" accept="audio/*"></FileInput>
    </el-form-item>
    <el-form-item label="音频原文" v-if="config.audioText">
      <PinyinGridInput :text.sync="form.audioText" :pinyin.sync="form.audioPinyin"></PinyinGridInput>
    </el-form-item>
    <el-form-item label="正确答案" class="exr-answers">
      <div class="pxt-selection">
        <el-cascader
        :options="answers" 
        placeholder="请选择答案"
        v-model="form.answer"></el-cascader>
      </div>
    </el-form-item>
    <el-form-item label="答案音频" v-if="config.answerAudio">
      <FileInput v-model="form.answerAudio" accept="audio/*"></FileInput>
    </el-form-item>
    <ShowAnswer v-model="form" :config="config"></ShowAnswer>
  </div>
</template>

<script>
  import basexzt from './base-xzt.js'
  import dialog from '@/components/mixins/dialog.js'
  import PinyinPreview from "@/components/PinyinPreview"
  import PinyinInput from "@/components/PinyinInput"
  import PinyinGridInput from "@/components/PinyinGridInput"
  import FileInput from "@/components/FileInput"
  import ImageInput from "@/components/ImageInput"
  import ShowAnswer from "./ShowAnswer"
  export default {
    name: 'XktcForm',
    components: {
      PinyinPreview,
      PinyinInput,
      PinyinGridInput,
      FileInput,
      ImageInput,
      ShowAnswer,
    },
    mixins: [basexzt,dialog],
    data () {
      return {
        selections: [[]],
        blankLength: 1
      }
    },
    created () {
      this.initFormData(this.form)
    },
    watch: {
      model (val) {
        this.initFormData(val)
      },
      "form.subject" (val, oldVal) {
        if (val === oldVal) return
        if (val) {
          let subject = val.replace(/[_＿]{2,}/g, '__')
          if (this.form.subject !== subject) {
            this.$nextTick(() => {
              this.form.subject = subject
            })
          }
          let blanks = val.match(/__/g)
          this.blankLength = blanks ? blanks.length : 0
        } else {
          this.blankLength = 0
        }
      }
    },
    computed: {
      answers () {
        return this.permutate(this.blankLength, '')
      }
    },
    methods: {
      initFormData (obj) {
        this.blankLength = obj.subject ? obj.subject.match(/[_＿]{2,}/g).length : 1
        obj.itemsType = this.config.items
        let arr = obj.answers || []
        this.selections = arr.concat([[]])
      },
      permutate (dep, base) {
        let arr = []
        let items = [{ text: '_' }, ...this.form.items]
        let len = items.length
        let path = '/' + base + '/'
        if (base) base += '/'
        for (let i = 0; i < len; i++) {
          if (i === 0 || path.indexOf('/' + i + '/') < 0) {
            let item = {
              value: i - 1,
              label: items[i].text ? items[i].text : ''
            }
            if (dep > 1) {
              item.children = this.permutate(dep - 1, base + i)
            }
            arr.push(item)
          }
        }
        return arr
      },
      addAnswer () {
        this.selections.push([])
      },
      removeAnswer (index) {
        if (this.selections.length <= 1) {
          this.selections.splice(index, 1, [])
        } else {
          this.selections.splice(index, 1)
        }
        this.form.answers = this.selections.filter(item => item.length > 0)
      },
      updateAnswer () {
        this.form.answers = this.selections.filter(item => item.length > 0)
        if (this.selections[this.selections.length - 1].length > 0) {
          this.selections.push([])
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .exr-form-subject{
    display: flex;
    flex-wrap: wrap;
    margin-left: -8px;
    > div{
      flex: 1;
      margin-left: 8px;
      min-width: 300px;
    }
  }
  .exr-flex-row{
    display: flex;
    flex-wrap: wrap;
    margin: 0 -8px;
    > div{
      flex: 1;
      margin-left: 8px;
    }
  }
  .exr-items{
    .exr-item{
      display: flex;
      margin-left: -8px;
      > .el-input{
        flex: 1;
        margin-left: 8px;
      }
      > .el-button{
        width: 40px;
        height: 40px;
        padding: 0;
        line-height: 40px;
        text-align: center;
        margin-left: 8px;
      }
    }
    .exr-item-wrap + .exr-item-wrap{
      margin-top: 12px;
    }
  }
  .pxt-selection{
    display: flex;
    margin-bottom: 8px;
    > .el-cascader{
      flex: 1;
    }
    > .el-button{
      margin: 0 0 0 8px;
      height: 40px;
    }
  }
</style>
